import React from 'react';
import styled from 'styled-components';

const FooterOuter = styled.footer`
  flex-shrink: 0;
  width: 100%;
  margin-top: auto;
  border-top: 1px solid ${(p) => p.theme.colors.grey[200]};
  background: ${(p) => p.theme.colors.grey[50]};
`;

const FooterInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 24px 28px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 16px 16px 24px;
  }
`;

const CompanyLine = styled.p`
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 700;
  color: ${(p) => p.theme.colors.grey[800]};
`;

const MetaGrid = styled.div`
  display: grid;
  gap: 6px 24px;
  font-size: 12px;
  line-height: 1.65;
  color: ${(p) => p.theme.colors.grey[600]};

  @media (min-width: 640px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

const Row = styled.span`
  display: block;
`;

const Label = styled.span`
  font-weight: 600;
  color: ${(p) => p.theme.colors.grey[700]};
  margin-right: 6px;
`;

const PolicyBlock = styled.section`
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid ${(p) => p.theme.colors.grey[200]};
`;

const PolicyTitle = styled.h2`
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 700;
  color: ${(p) => p.theme.colors.grey[800]};
`;

const PolicySummary = styled.p`
  margin: 0 0 12px;
  font-size: 12px;
  line-height: 1.65;
  color: ${(p) => p.theme.colors.grey[600]};
`;

const PolicyDetails = styled.details`
  font-size: 12px;
  line-height: 1.65;
  color: ${(p) => p.theme.colors.grey[600]};

  summary {
    cursor: pointer;
    font-weight: 600;
    color: ${(p) => p.theme.colors.grey[700]};
    list-style: none;
    padding: 8px 0;
    user-select: none;
    border-radius: 6px;
    outline-offset: 2px;
  }

  summary:focus-visible {
    outline: 2px solid ${(p) => p.theme.colors.primary.main};
  }

  summary::-webkit-details-marker {
    display: none;
  }

  summary::after {
    content: ' ▼';
    font-size: 10px;
    opacity: 0.7;
  }

  &[open] summary::after {
    content: ' ▲';
  }
`;

const PolicyList = styled.ul`
  margin: 0;
  padding: 0 0 4px 18px;
`;

const PolicyItem = styled.li`
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;

/**
 * 사업자등록증 기준 고지 (패스로) + 환불정책
 */
const SiteFooter = () => {
  return (
    <FooterOuter role="contentinfo" aria-label="사업자 및 환불 안내">
      <FooterInner>
        <CompanyLine>패스로 (Passro)</CompanyLine>
        <MetaGrid>
          <div>
            <Row>
              <Label>대표</Label>
              허재영
            </Row>
            <Row>
              <Label>사업자등록번호</Label>
              238-51-01057
            </Row>
            <Row>
              <Label>개업일</Label>
              2025년 6월 13일
            </Row>
          </div>
          <div>
            <Row>
              <Label>사업장 소재지</Label>
              제주특별자치도 제주시 한림읍 명상로 232-6
            </Row>
            <Row>
              <Label>업태</Label>
              정보통신업
            </Row>
            <Row>
              <Label>종목</Label>
              소프트웨어 개발 및 공급업
            </Row>
          </div>
        </MetaGrid>

        <PolicyBlock aria-labelledby="footer-refund-heading">
          <PolicyTitle id="footer-refund-heading">환불정책</PolicyTitle>
          <PolicySummary>
            유료 서비스(월 이용권 등)는「전자상거래 등에서의 소비자보호에 관한 법률」등 관련 법령을 준수합니다. 환불 가능 여부는 결제·이용 시점 및
            제공된 디지털 콘텐츠 이용 여부에 따라 달라질 수 있습니다.
          </PolicySummary>
          <PolicyDetails>
            <summary>상세 환불 기준 보기</summary>
            <PolicyList>
              <PolicyItem>
                <strong>청약철회(결제 취소)</strong>: 결제일로부터 7일 이내 청약철회를 요청하실 수 있습니다. 다만 이미 디지털 콘텐츠(강의·학습
                자료 등)의 제공이 개시된 경우 등 법령에서 정한 사유에 해당하면 청약철회가 제한될 수 있습니다.
              </PolicyItem>
              <PolicyItem>
                <strong>월 이용권</strong>: 이용 기간이 개시된 후에는 원칙적으로 중도 해지에 따른 일할 환불이 제공되지 않을 수 있습니다. 결제
                오류·중복 결제 등 회사 귀책 사유가 있는 경우에는 사실 확인 후 전액 또는 일부 환불을 진행할 수 있습니다.
              </PolicyItem>
              <PolicyItem>
                <strong>접수 방법</strong>: 환불·취소 문의는 서비스 내 안내 또는 고객 지원 채널로 접수해 주세요. 접수 후 영업일 기준으로
                처리되며, 결제 수단·PG사 정책에 따라 환불 완료까지 며칠이 소요될 수 있습니다.
              </PolicyItem>
              <PolicyItem>
                <strong>유의</strong>: 본 안내는 법령·서비스 정책 변경에 따라 수정될 수 있으며, 세부 조건은 결제 시 고지되는 내용 및 별도 약관을
                따릅니다.
              </PolicyItem>
            </PolicyList>
          </PolicyDetails>
        </PolicyBlock>
      </FooterInner>
    </FooterOuter>
  );
};

export default SiteFooter;
